import './styles.scss';
import whiteIdentity from '../../assets/white-identity.png'
import { useState } from 'react';


function Header() {

    const [mobileMenu, setMobileMenu] = useState(false);

    return (
        <div className="container-header">
            <div className='header-left'>
                <img src={whiteIdentity} alt='LM' />
            </div>
            <div className='header-right'>
                <ul>
                    <li>
                        <a href='#about-section'>Dra. Lais</a>
                    </li>
                    <li>
                        <a href='#treatments-section'>Tratamentos</a>
                    </li>
                    <li>
                        <a href='#footer-section'>Contato</a>
                    </li>
                </ul>
                <div className='header-ul-mobile'>
                    <i
                        className="fa fa-bars"
                        aria-hidden="true"
                        onClick={() => setMobileMenu(!mobileMenu)}
                    ></i>
                    {mobileMenu && (
                        <ul className="mobile-menu">
                            <li><a href='#about-section'>Dra. Lais</a></li>
                            <li><a href='#treatments-section'>Tratamentos</a></li>
                            <li><a href='#footer-section'>Contato</a></li>
                        </ul>
                    )}
                </div>
                <div className='btnSchedule'>
                    <a href="https://wa.me/5571997303062" target="_blank" rel="noopener noreferrer">Agendar Consulta</a>
                </div>
            </div>

        </div>
    );
}

export default Header;
